import(/* webpackMode: "eager" */ "/app/src/app/news/page.tsx");
